import { useSessionAuth } from "~/composables/useSessionAuth";
import { useAuth } from "~/store/auth";
import api from "~/utils/auth/api";
import { removeCookie, setWildCardCookie } from "~/utils/cookie-util";

const useSessionCheck = () => {
	const { isTokenNearExpiry } = useSessionAuth();
	const auth = useAuth();
	let interval: ReturnType<typeof setInterval>;

	const checkAuth = async () => {
		const authToken = useCookie("betway-auth");
		const authRefreshToken = useCookie("betway-refresh-token");
		if (authToken.value && isTokenNearExpiry(authToken.value)) {
			console.warn("Session expired. Resetting token...");
			await auth.login(authToken.value as string, authRefreshToken.value as string);
			api<{ access_token: string; refresh_token: string }>({
				url: "/Users/refresh-token",
				type: "auth",
				options: { method: "POST" },
				data: {
					refresh_token: authRefreshToken.value,
				},
			})
				.then((res) => {
					auth.token = res.access_token;
					auth.refresh_token = res.refresh_token;
					setWildCardCookie("betway-auth", res.access_token, 7);
					setWildCardCookie("betway-refresh-token", res.refresh_token, 7);
					return res;
				})
				.catch(() => auth.logout());
		}
	};

	const startAuthCheck = () => {
		window.addEventListener("focus", checkAuth);
	};

	const stopAuthCheck = () => {
		window.removeEventListener("focus", checkAuth);
	};

	onMounted(() => {
		interval = setInterval(() => {
			checkAuth();
		}, 5000);
	});

	onUnmounted(() => clearInterval(interval));

	return { startAuthCheck, stopAuthCheck };
};

export default useSessionCheck;
